module.exports = "/packs/images/pages/guest_passes/your-free-day-pass~11d6bf93e9d9b269b7c5c1b609e0a0c5.gif";